import React from "react";
import TextField from "../TextField";
import { PatternFormat } from "react-number-format";
import { adminChamberFieldSx } from "../dashboard/formStyles";

interface PhoneNumberFormatProps {
  formikVal: string;
  formikErrors?: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: React.ReactNode;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  placeholder?: string;
  onBlur?: () => void;
  containerClassName?: string;
  appearance?: "default" | "adminChamber";
}

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const PhoneNumberCustomInput = React.forwardRef<any, CustomProps>(
  function PhoneNumberCustomInput(props, ref) {
    const { onChange, name, ...other } = props;

    return (
      <PatternFormat
        {...other}
        getInputRef={ref}
        format="(###) ###-####"
        mask="_"
        onValueChange={(values) => {
          onChange({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
      />
    );
  },
);

const PhoneNumberFormat: React.FC<PhoneNumberFormatProps> = ({
  formikVal,
  formikErrors,
  handleChange,
  label,
  error,
  helperText,
  required = false,
  placeholder,
  onBlur,
  containerClassName = "mb-5 min-w-0",
  appearance = "default",
}) => {
  return (
    <div className={containerClassName}>
      <div className="mb-2 flex items-center">
        <label
          htmlFor="phoneNumber"
          className="block text-base font-semibold text-black"
        >
          {label}
          {required ? <span className="text-red-500">*</span> : null}
        </label>
      </div>
      <TextField
        type="tel"
        id="phoneNumber"
        name="phoneNumber"
        value={formikVal || ""}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        fullWidth
        sx={appearance === "adminChamber" ? adminChamberFieldSx : undefined}
        InputProps={{
          inputComponent: PhoneNumberCustomInput as any,
        }}
      />
    </div>
  );
};

export default PhoneNumberFormat;
